import { BaseButton } from "@/components/atom/button/BaseButton";
import { FormTextInput } from "@/components/atom/textInput/form/FormTextInput";
import { PrinterAutoComplete } from "@/components/organism/autoComplete/print/printer-autoComplete";
import FormTemplate from "@/components/template/form/FormTemplate";
import { COMMON_TEXT } from "@/constants/text";
import { useModal } from "@/context/ModalStackManager";
import { useWorkHandler } from "@/hooks/handler/useWorkHandler";
import { useWorkDataStore } from "@/store/work.store";
import { useForm } from "@mantine/form";
import { OperationAutoComplete } from "@/components/organism/autoComplete/operation/operation-autoComplete";

const Work = Object.assign(
  {},
  {
    Template: FormTemplate,
    Button: BaseButton,
    TextInput: FormTextInput,
    Select: PrinterAutoComplete,
    OperationAutoComplete: OperationAutoComplete,
  }
);


export const WorkOperationUpdateForm = () => {
  const { closeModal } = useModal();
  const { onSubmit } = useWorkHandler();
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const form = useForm({
    initialValues: {
      id: work?.id || 1,
      operationCode: work?.description || '', //공정코드
    },
  });

  const handleSubmit = () => {
    onSubmit({
      DefaultApiWorksWorkIdPutRequest: {
        workId: form.values.id as number,
        worksWorkIdDeleteRequest: {
          description: form.values.operationCode,
        },
      },
    });
    closeModal({});
  };

  return (
    <Work.Template onSubmit={handleSubmit} onCancel={() => closeModal({})}>
      <Work.OperationAutoComplete
        label={COMMON_TEXT.LABEL.OPERATION_CODE}
        defaultValue={form.values?.operationCode}
        {...form.getInputProps("operationCode")}
      />
    </Work.Template>
  );
};
